import namespace from './namespace';
import {mapUsersByEmailResultEnum} from "./enums/mapUsersByEmailResultEnum";

export default {
    [namespace.mutations.SET_DEFAULT_VALUES](state, responseData) {
        if (responseData.DefaultValues !== undefined) {
            state[namespace.state.DEFAULT_VALUES] = responseData.DefaultValues;
        }
        if (responseData.SpecialValues !== undefined) {
            state[namespace.state.SPECIAL_VALUES] = responseData.SpecialValues;
        }
    },
    [namespace.mutations.SET_AVAILABLE_VALUES](state, values) {
        let availableValues = Object.values(values).map(value => Object.assign({}, value));
        state[namespace.state.AVAILABLE_VALUES] = availableValues;
    },
    [namespace.mutations.SET_JIRA_VALUES] (state, responseData) {
        const tfsValues = Object.fromEntries(
            Object.entries(state[namespace.state.AVAILABLE_VALUES]).filter(([key, value]) => value.kind === 'TFS')
        );
        const jiraValues = responseData;
        const jiraValuesArray = Object.values(jiraValues.available);
        const tfsValuesArray = Object.values(tfsValues);
        const merged = Array.from(jiraValuesArray).concat(tfsValuesArray);
        state[namespace.state.AVAILABLE_VALUES] = merged;
    },
    [namespace.mutations.SHOW_LOADER](state, loaderVisible) {
        state[namespace.state.LOADER_VISIBLE] = loaderVisible;
    },
    setUsersMappedByEmail(state, numberOfMappings) {
        state.usersMappedByEmailCounter = numberOfMappings;
    },
    hideMappedByEmailFlag(state) {
        state.mapUsersByEmailResult = mapUsersByEmailResultEnum.NONE;
        state.mapUsersByEmailResultMessage = '';
    },
    setUsersMappingByEmailResult(state, result) {
        state.mapUsersByEmailResult = result.status;
        let message = {
            title: '',
            content: ''
        };
        switch (result.status) {
            case mapUsersByEmailResultEnum.WARNING:
                message.title = 'No users could be mapped';
                message.content = 'No user account with matching e-mail was found.';
                break;
            case mapUsersByEmailResultEnum.SUCCESS:
                message.title = result.mappedUsersCounter + ' user(s) were mapped!';
                break;
            default:
        }
        state.mapUsersByEmailResultMessage = message;
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/usersMapping/mutations.js